import { RemoteData } from 'app/infrastructure/remote-data/remote-data';

import { CaseData, ApiResponse, CasePermissions, BowtieSupported, SurveyManagerSupportedData, 
  RiskEvaluationSupported } from 'app/types-shared';
import { endpoint } from 'app/area/case/endpoints';
import { RiskMatrixDefinition } from 'app/area/case/types-store';

export const api = {
  caseRiskMatrixDefinition: async (caseTypeId: number): Promise<RiskMatrixDefinition> => {

    //TODO: use ETag caching for ui-definitions
    const response = await new RemoteData(endpoint.riskMatrix).resource<ApiResponse<RiskMatrixDefinition>>()
      .withId(caseTypeId)
      .single();

    return response.data;
  },

  case: async (id: number): Promise<CaseData> => {

    //TODO: use ETag caching for data
    const response = await new RemoteData(endpoint.case).resource<ApiResponse<CaseData>>()
      .withId(id)
      .single();

    return response.data;
  },

  casePermissions: async (id: number): Promise<CasePermissions> => {

    const response = await new RemoteData(endpoint.casePermissions).resource<ApiResponse<CasePermissions[]>>()
      .filter({ caseId: id })
      .single();
    
    return response.data[0];
  },

  bowtieSupported: async (id: number): Promise<BowtieSupported> => {

      const response = await new RemoteData(endpoint.bowtieSupported).resource<ApiResponse<BowtieSupported[]>>()
      .filter({ caseId: id })
      .single();

    return response.data[0];
  },

  deleteCase: async (caseId: number) => {
    return new RemoteData(endpoint.case)
      .resource<ApiResponse<CaseData>>()
      .withId(caseId)
      .httpDelete(caseId);
  },

  surveyManagerSupported: async (id: number): Promise<SurveyManagerSupportedData> => {
    
    const response = await new RemoteData(endpoint.surveyManagerSupported).resource<ApiResponse<SurveyManagerSupportedData[]>>()
      .filter({ caseId: id })
      .single();

    return await response.data[0];
  },
  
  riskEvaluationSupported: async (id: number): Promise<RiskEvaluationSupported> => {

    const response = await new RemoteData(endpoint.riskEvaluationSupported).resource<ApiResponse<RiskEvaluationSupported[]>>()
    .filter({ caseId: id })
    .single();

    return response.data[0];
  }
};
